export var InspectionTypeMap = {
  INSPECTIONHOME: 'home',
  INSPECTION: 'store'
};
export var INSPECTION_TYPE = {
  HOME: 'INSPECTIONHOME'
};